import { ActivitySaleItemFormType } from './form-type';

export function activitySaleGuestDetailCalculation({
  activitySaleGuestDetails,
}) {
  return (activitySaleGuestDetails || []).reduce(
    (prev, curr) => prev + (curr.totalPrice || 0),
    0,
  );
}

export function activitySaleGuestCalculation({ activitySaleGuests }) {
  return activitySaleGuests.reduce(
    (prev, curr) =>
      prev +
      activitySaleGuestDetailCalculation({
        activitySaleGuestDetails: curr.activitySaleGuestDetails,
      }),
    0,
  );
}

export function totalActivitySaleCalculation({
  activitySales,
  discount,
  otherCost,
}: {
  activitySales: ActivitySaleItemFormType[];
  discount: number;
  otherCost: number;
}) {
  let tempTotal: number = 0;
  tempTotal = activitySales.reduce((prev, curr) => {
    const addons = curr.activitySaleAddOns.reduce(
      (prevAddOns, currAddOns) => prevAddOns + currAddOns.price,
      0,
    );

    const guestDetails = activitySaleGuestCalculation({
      activitySaleGuests: curr.activitySaleGuests,
    });

    return prev + guestDetails + addons;
  }, 0);

  tempTotal -= discount || 0;
  tempTotal += otherCost || 0;
  return tempTotal;
}

export function activityRescheduleCalculation({ activitySales }) {
  return activitySales.reduce(
    (prev, curr) => prev + (curr.rescheduleFee || 0),
    0,
  );
}
